export default __webpack_public_path__ + "static/media/rost.75a44115.svg";